<template>
  <div class="container-fluid mb-5">
    <div class="row">
      <h2 class="text-center mx-auto pt-5 heading-lg">{{ productSupportData.heading }}</h2>

      <div class="col-sm-12 px-0">
        <div class="search-results-container" :class="`-mode-${$root.mode}`">
          <div class="container">
            <div class="nav-bar text-center row">
              <div class="col-12 col-md-6">
                <div class="row">
                  <a v-for="item in tabContent" :key="`tab-${getSlug(item.name)}`" class="nav-bar-item col"
                    :class="{ active: selectedTabType === getSlug(item.name) }" href="javascript:void(0);"
                    @click.prevent="selectTabType(getSlug(item.name))">{{ item.name }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="healthcare-professionals-tab-wrapper" v-for="item in visibleTabContent"
        :key="`tab-content-${getSlug(item.name)}`">
        <div v-for="(stepData, index) in item.items || []" :key="`item-${getSlug(item.name)}-${index}`"
          class="row py-5 items" v-bind:class="{
            'items-border-bottom': index !== (item.items || []).length - 1,
          }">
          <div class="col-md-5">
            <h4 class="heading d-lg-block d-md-none d-block">
              {{ stepData.heading }}
            </h4>
            <figure class="embed-responsive embed-responsive-1by1 stage">
              <template v-if="getAprimoVideoUrl(stepData)">
                <div v-if="!isVideoPlaying(item, index)" class="video-thumbnail" @click="playVideo(item, index)">
                  <img v-if="stepData.aprimo_thumbnail" :src="stepData.aprimo_thumbnail"
                    :alt="stepData.heading || 'Video thumbnail'" class="video-thumbnail-image" />
                  <div v-else class="video-thumbnail-fallback">Play video</div>

                  <button class="video-play-button vjs-big-play-button-product" type="button" title="Play Video"
                    aria-label="Play video">
                    <span class="vjs-icon-placeholder" aria-hidden="true"></span>
                    <img class="img-fluid" src="@/assets/images/play-button.svg" />
                  </button>

                </div>

                <video v-else :ref="`aprimo-video-${getVideoKey(item, index)}`"
                  class="embed-responsive-item aprimo-video video-js vjs-default-skin" controls playsinline
                  preload="auto" style="position: absolute; top:0; right:0; bottom:0; left:0; width:100%; height:100%;">
                  <!-- Add dynamic track for captions if URL exists -->
                  <track v-if="getAprimoSubtitleUrl(stepData)" kind="captions" :src="getAprimoSubtitleUrl(stepData)"
                    srclang="en" label="English" />
                    
                </video>
              </template>
              <template v-else>
                <div class="video-thumbnail-fallback">Video unavailable</div>
              </template>
            </figure>
          </div>
          <div class="col-md-7 mt-5 mt-md-0 mt-lg-5 pl-md-5 pl-4">
            <h4 class="heading d-lg-none d-md-block d-none">
              {{ stepData.heading }}
            </h4>
            <p v-html="stepData.steps" class="steps"></p>
          </div>
        </div>
        <p class="disclaimer-text" v-if="item.disclaimer !== ''" v-html="item.disclaimer"></p>
      </div>
    </div>
  </div>
</template>

<script>
import UrlHelpers from "../../mixins/url-helpers";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "product-support", // global_search_results
  props: ["data"],
  created() {
    if (window.bus) {
      window.bus.$emit("navigation:reversed", true);
    }
    // bus.$emit("navigation:search-disabled", true);
    this.resetPlaybackState();
  },
  activated() {
    this.resetPlaybackState();
  },
  mixins: [UrlHelpers],
  data() {
    const productSupportData = Array.isArray(this.data)
      ? this.data[0] || {}
      : this.data || {};
    const tabContent = Array.isArray(productSupportData.tab_content)
      ? productSupportData.tab_content
      : [];
    const sectionResultGroupTypes = tabContent.map((a) => this.getSlug(a.name));

    return {
      slider: null,
      loading: false,
      selectedTabType: sectionResultGroupTypes[0]
        ? sectionResultGroupTypes[0]
        : "before-you-buy",
      sectionResultGroupTypes,
      playingVideos: {},
      playerInstances: {},
      resultGroups: [],
    };
  },
  computed: {
    productSupportData() {
      return Array.isArray(this.data) ? this.data[0] || {} : this.data || {};
    },
    tabContent() {
      return Array.isArray(this.productSupportData.tab_content)
        ? this.productSupportData.tab_content
        : [];
    },
    visibleTabContent() {
      return this.tabContent.filter(
        (item) => this.selectedTabType === this.getSlug(item.name)
      );
    },
    tabAwareResultGroup() {
      return this.getResultGroupByType(this.selectedTabType);
    },
  },
  methods: {
    shouldShowNoResultsForTabType(type) {
      if (this.sectionResultGroupTypes.includes(type)) {
        return !this.numResultsForTabType(type);
      }

      return true;
    },
    selectTabType(tab) {
      this.resetPlaybackState();
      this.selectedTabType = tab;
    },
    resetPlaybackState() {
      this.disposeAllPlayers();
      this.playingVideos = {};
    },
    getVideoKey(item, index) {
      return `${this.getSlug(item.name)}-${index}`;
    },
    isVideoPlaying(item, index) {
      return !!this.playingVideos[this.getVideoKey(item, index)];
    },
    playVideo(item, index) {
      const key = this.getVideoKey(item, index);
      this.$set(this.playingVideos, key, true);
      this.$nextTick(() => {
        this.initVideoPlayer(item, index);
      });
    },

  
    initVideoPlayer(item, index) {
      const key = this.getVideoKey(item, index);
      const refName = `aprimo-video-${key}`;
      const refEl = this.$refs[refName];
      const videoEl = Array.isArray(refEl) ? refEl[0] : refEl;
      const stepData = (item.items || [])[index] || {};
      const src = this.getAprimoVideoUrl(stepData);
      const subtitleUrl = this.getAprimoSubtitleUrl(stepData);

      if (!videoEl || !src) {
        return;
      }

      if (this.playerInstances[key]) {
        try {
          const player = this.playerInstances[key];
          player.src({ src, type: "application/x-mpegURL" });
          
          if (subtitleUrl) {
            player.addRemoteTextTrack({
              kind: 'captions',
              src: subtitleUrl,
              srclang: 'en',
              label: 'English'
            }, false);
          }

          player.play();
        } catch (e) {
          // ignore player reuse errors
        }
        return;
      }

      try {
        const instance = videojs(videoEl, {
          controls: false,
          autoplay: true,
          preload: "auto",
          fluid: true,
          controlBar: {
            playToggle: true,
            currentTimeDisplay: true,
            timeDivider: true,
            durationDisplay: true,
            progressControl: true,
            remainingTimeDisplay: false,
            volumePanel: {
              inline: false,
            },
            // This forces the CC/Subtitles button to always render in the control bar
            subsCapsButton: true,
            fullscreenToggle: true,
            pictureInPictureToggle: true,
          },
          html5: {
            vhs: {
              enableLowInitialPlaylist: true,
            },
          },
          sources: [
            {
              src,
              type: "application/x-mpegURL",
            },
          ],
        });

        instance.one("canplay", () => {
          instance.controls(true);
        });

        this.$set(this.playerInstances, key, instance);
      } catch (e) {
        // ignore init errors to keep UI responsive
      }
    },
    
    disposeAllPlayers() {
      Object.keys(this.playerInstances).forEach((key) => {
        const instance = this.playerInstances[key];
        if (!instance) {
          return;
        }

        try {
          instance.dispose();
        } catch (e) {
          // ignore dispose errors
        }
      });

      this.playerInstances = {};
    },
    getAprimoVideoUrl(stepData) {
      return stepData.aprimo_url || "";
    },
    getAprimoSubtitleUrl(stepData) {
      return stepData.aprimo_subtitle || "";
    },
    getResultGroupByType(type) {
      const resultGroup = this.resultGroups.filter((rg) => rg.type === type);

      if (resultGroup.length) {
        return resultGroup[0];
      }

      return null;
    },
    getSlug(name) {
      return name
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
    },
  },
  beforeDestroy() {
    this.disposeAllPlayers();
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

:deep(.aprimo-video .vjs-loading-spinner) {
  display: none !important;
}

.search-results-container {
  margin-bottom: 3.375rem;
  background-color: $cc-resmed-hero-blue;

  .results-description {
    span {
      font-family: "Plus Jakarta Sans", sans-serif;
      font-weight: 500;
    }
  }

  &.-mode-md,
  &.-mode-sm,
  &.-mode-xs {
    .nav-bar {
      // flex-direction: column;
      // align-items: flex-start;
      margin-bottom: 0;

      .nav-bar-item::after {
        background-color: transparent;
        margin-top: 0;
        // margin-top: 0.375rem;
      }

      .nav-bar-item:not(.active) {
        color: $cc-resmed-grey-30;
      }
    }
  }
}

.nav-bar {
  margin: 0 -0.625rem 2.8125rem -0.625rem;
  display: flex;
  justify-content: center;

  .nav-bar-item {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.31;
    letter-spacing: normal;
    color: #fff;
    position: relative;
    padding: 0.625rem 1.25rem;
    border-left: 1px solid #fff;
    font-size: 1.125rem;

    &:last-child {
      border-right: 1px solid #fff;
    }

    &.active {
      background-color: #424243;

      &::after {
        content: "";
        position: absolute;
        left: 45%;
        top: 100%;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #424243;
      }
    }
  }
}

.healthcare-professionals-tab-wrapper {
  margin-top: -3rem;
}

.items-border-bottom {
  border-bottom: 1px solid #ccc;
}

.heading {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 400;
  font-size: 1.5rem;
}

.steps {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-weight: 400;

  strong {
    font-family: "Plus Jakarta Sans", sans-serif !important;
    font-weight: 500;
  }
}

.video-thumbnail {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  overflow: hidden;
  background: #000;
}

.video-thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 0;
  border-radius: 999px;
  padding: 0.6rem 1rem;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
  background: rgba(0, 0, 0, 0.65);
}

.video-thumbnail-fallback {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #111;
  color: #fff;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 0.95rem;
}

.healthcare-professionals-tab-wrapper {

  &.-mode-xs,
  &.-mode-sm,
  &.-mode-md {
    .component-e505c56b {
      padding-top: 0;
    }

    .headline-text {
      padding-top: 0 !important;
      padding-left: 3.5rem;
      padding-right: 3.5rem;
    }
  }

  .steps {
    li {
      padding-bottom: 10px;
    }
  }
}

.video-play-button.vjs-big-play-button-product {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6.25rem !important;
  height: 6.25rem !important;
  border: 0;
  border-radius: 50% !important;
  background-color: rgba(255, 255, 255, 0.6) !important; // opacity baked into background, not the button
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  .vjs-icon-placeholder {
    display: none; // hide the default vjs icon glyph, we're using our own image
  }

  img {
    width: 62%;
    height: 62%;
    object-fit: contain;
    opacity: 1 !important; // always fully visible, independent of button background opacity
    pointer-events: none; // clicks pass through to the button
  }
}

.video-thumbnail .vjs-big-play-button-product:hover {
  background-color: rgba(132, 132, 132, 0.8) !important;
}
</style>